import { Component, Inject,  OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-meli-category-predictor',
    templateUrl: './meli-category-predictor.component.html',
    styleUrls: ['./meli-category-predictor.component.scss'],
    standalone: false
})
export class MeliCategoryPredictorComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>
) { }

  ngOnInit(): void {
      
  }

  select(cat){
    this.dialogRef.close(cat);
  }

}
